module.exports = __webpack_public_path__ + "img/placeholder-1.f2902a88.jpg";